import { useEffect, useState } from 'react';
import apiClient from '../../services/apiClientService';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

const useInitiateSocialLogin = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  // Back from Google, the browser may restore this page as it was left, button spinning.
  useEffect(() => {
    const resetOnRestore = (event) => event.persisted && setLoading(false);
    window.addEventListener('pageshow', resetOnRestore);
    return () => window.removeEventListener('pageshow', resetOnRestore);
  }, []);

  // On success the caller leaves for Google, so the button keeps spinning until the page goes.
  const initiateSocialLogin = async () => {
    setLoading(true);
    try {
      const url = `/v1/public/tenants/${tenantId}/auth/initiate-social-login`;
      const response = await apiClient.get(url);
      const redirectUrl = response?.data?.redirectUrl;
      if (!redirectUrl) {
        setLoading(false);
      }
      return redirectUrl;
    } catch (err) {
      setLoading(false);
      handleError(err);
    }
  };

  return { initiateSocialLogin, loading };
};

export default useInitiateSocialLogin;
